<li  class="hover-anchor" (click)="callAction()">
  {{labelOnMenu ? labelOnMenu : label}}

  <button [ngClass]="{ 'info-button selected': isTooltipOpened(), 'info-button': !isTooltipOpened() }" *ngIf="isTooltipAvailable()" [satPopoverAnchor]="p" (click)="openclose($event);">i</button>


  <sat-popover #p horizontalAlign="after" verticalAlign="center" >
    <div class="tooltip-wrapper" >
      <h4 >
        {{contextualHelpModel?.functionality}}
      </h4>
      <label>
        {{contextualHelpModel?.descriptionText}}
      </label>
      <span *ngIf="contextualHelpModel?.link != null">
        <a [href]="contextualHelpModel?.link" target="_blank">{{contextualHelpModel.linkName}}</a>
      </span>
    </div>
  </sat-popover>
</li>

<input hidden type="file" #fileElement [accept]="fileFormats.fileExtension" (click)="$event.target.value=''" (change)="fileExplorerCallBack($event.target.files[0]);">

